"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchUsers = void 0;
const react_1 = require("react");
const providers_1 = require("../providers");
function useSearchUsers() {
    const [users, setUsers] = (0, react_1.useState)([]);
    const userService = (0, providers_1.useUserService)();
    const search = (query) => __awaiter(this, void 0, void 0, function* () {
        if (!query) {
            setUsers([]);
        }
        else {
            const searchedUsers = yield (userService === null || userService === void 0 ? void 0 : userService.searchUsers(query));
            const autocompleteOptions = searchedUsers === null || searchedUsers === void 0 ? void 0 : searchedUsers.map(({ username, id, image_url }) => ({
                identifier: id,
                image: image_url,
                label: username,
            }));
            setUsers(autocompleteOptions);
        }
    });
    return { users, search };
}
exports.useSearchUsers = useSearchUsers;
